<template>
  <div>
    <div
        :class="modalClasses"
        tabindex="-1"
        role="dialog"
        @click="modalClick($event)"
    >

      <div :class="dialogClasses" role="document">
        <div :class="contentClasses">
          <slot name="header-wrapper">
            <header class="modal-header">
              <slot name="header">
                <h5 class="modal-title">
                  {{ title }} <span v-if="alertMsg" class="alert" :class="alertClass"> {{ getTranslation(alertMsg) }}</span>
                </h5>
                <small class="text-muted" v-if="modalDescription"><br/>{{ modalDescription }}</small>
                <CButtonClose @click="hide($event)"/>
              </slot>
            </header>
          </slot>
          <slot name="body-wrapper">
            <div class="modal-body">
              <slot></slot>
            </div>
          </slot>
          <slot name="footer-wrapper">
            <footer class="modal-footer">
              <slot name="footer">
                <button
                    type="button"
                    class="btn btn-secondary"
                    @click="clickCANCEL"
                >
                  {{ getTranslation(cancelButtonLabel) }}
                </button>
                <button
                    v-if="okButtonLabel"
                    type="button"
                    :class="btnClasses"
                    @click="clickOK"
                >
                  {{ getTranslation(okButtonLabel) }}
                </button>
              </slot>
            </footer>
          </slot>
        </div>
      </div>
    </div>
    <div
        v-if="backdrop && (visible || isTransitioning)"
        :class="backdropClasses"
    >
    </div>
  </div>
</template>

<script>


export default {
  props: {
    cancelButtonLabel: {
      type: String,
      default: 'cancel'
    },
    okButtonLabel: String,
    modalDescription: String,
    show: Boolean,
    centered: Boolean,
    scrollable: Boolean,
    title: String,
    alertMsg: {
      type:String,
      default:''
    },
    alertClass: [ String, Array, Object ],
    size: {
      type: String,
      validator: val => [ '', 'sm', 'lg', 'xl' ].includes(val)
    },
    color: String,
    borderColor: String,
    fade: {
      type: Boolean,
      default: true
    },
    backdrop: {
      type: Boolean,
      default: true
    },
    closeOnBackdrop: {
      type: Boolean,
      default: false
    },
    addContentClasses: [ String, Array, Object ]
  },
  data() {
    return {
      visible: this.show,
      isTransitioning: false,
      timeout: null
    }
  },
  computed: {
    backdropClasses() {
      return {
        'modal-backdrop': true,
        'fade': this.fade,
        'show': this.visible || !this.fade
      }
    },
    modalClasses() {
      return [
        'modal overflow-auto',
        {
          'fade': this.fade,
          'show': this.visible,
          'd-block': this.visible || this.isTransitioning,
          [`modal-${ this.color }`]: this.color
        }
      ]
    },
    dialogClasses() {
      return [
        'modal-dialog',
        {
          'modal-dialog-centered': this.centered,
          [`modal-${ this.size }`]: this.size,
          'modal-dialog-scrollable':this.scrollable
        }
      ]
    },
    contentClasses() {
      return [
        this.addContentClasses,
        'modal-content',
        {
          [`border-${ this.borderColor }`]: this.borderColor
        }
      ]
    },
    btnClasses() {
      return [ `btn btn-${ this.color || 'primary' }` ]
    }
  },
  watch: {
    show(val) {
      this.toggle(val)
    }
  },
  methods: {
    clickCANCEL(e) {
      this.$emit('update:show', false);
      this.$emit('modalCancel');
    },
    clickOK(e) {
      this.$emit('clickOK');
    },
    modalClick(e) {
      if ( e.target === this.$el.firstElementChild && this.closeOnBackdrop ) {
        this.hide(e)
      }
    },
    hide(e, accept = false) {
      this.$emit('update:show', false, e, accept);
      this.$emit('modalCancel');
    },
    toggle(newVal) {
      setTimeout(() => {
        this.visible = newVal
      }, 0)
      if ( this.fade ) {
        this.isTransitioning = true
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.isTransitioning = false
        }, 150)
      }
    }
  }
}
</script>
